import { a as validateModuleId, v as validateTopic, l as loggingOptions, e as logger, b as setLog, s as setOGlobal, Q as QBusStore, M as ModuleEventsManager, i as initOptions, k as callbackToResolve, m as moduleEventName } from './ea273712.mjs';

/*                                                   */
const log = logger("event-q-bus:utils");
function addModuleSubscription({ params, callback, register, }) {
    validateModuleId(params.moduleId);
    const ids = Array.isArray(params.dependencyIds) ? params.dependencyIds : [params.dependencyIds];
    ids.forEach((i) => validateModuleId(i));
    if (typeof callback === "function") {
        register({ moduleId: params.moduleId, dependencyIds: ids }, callback);
        return callback;
    }
    return null;
}
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
function addSubscription({ store, topicName, callback, singleRun, }) {
    validateTopic(topicName);
    log(topicName, "add new subscription with options: %o", { singleRun });
    if (typeof callback === "function") {
        const topic = store.getOrAddTopic(topicName);
        /*                                                                                          */
        const listener = topic.addListener(callback, singleRun);
        /*                                          */
        if (!store.isBusMode) {
            log(topicName, "queue mode is on, dispatch from queue");
            /*                                              */
            topic.emitListenerWithQueuedData(listener);
        }
        else if (topic.retained) {
            log(topicName, "topic is retained, emit new subscriber immediatelly");
            topic.emitListener(listener, topic.retainedMessage);
        }
        return listener.callback;
    }
    return null;
}
function removeSubscription({ store, topicName, callback, }) {
    log(topicName, "remove subscription", callback === null || callback === void 0 ? void 0 : callback.name);
    const event = store.get(topicName);
    return event ? event.removeByCallback(callback) : false;
}
function publish({ store, topicName, data, retain, }) {
    validateTopic(topicName);
    const logData = { payload: data };
    if (loggingOptions.tracing) {
        const { stack } = Error("");
        /*                */
        logData.trace = stack
            ? stack.split("\n").slice(1)
            : /*                      */ /*                */ "";
    }
    log(topicName, "emit with:", logData);
    const topic = store.getOrAddTopic(topicName);
    if (!store.isBusMode) {
        /*                                               */
        topic.queueData(data);
    }
    if (retain === true || (topic.retained && retain !== false)) {
        topic.retained = true;
        topic.retainedMessage = data;
    }
    else if (topic.retained) {
        topic.retained = false;
        topic.retainedMessage = undefined;
    }
    /*                                      */
    return topic.emitAllListener(data);
}

/*                                                   */
/**
 *
 *
 */
class QBusImpl {
    /**
 *
 *
 */
    constructor(options = {}) {
        var _a;
        this.setLog = setLog;
        /*                                                */
        this.store =
            options.store ||
                ((_a = window.o_global) === null || _a === void 0 ? void 0 : _a.eventQBusStore) ||
                setOGlobal("eventQBusStore", new QBusStore());
        this.moduleEvents =
            options.moduleEvents ||
                window.o_global.eventQBusModuleEvents ||
                setOGlobal("eventQBusModuleEvents", new ModuleEventsManager({ store: this.store }));
        initOptions();
    }
    get isBusMode() {
        return this.store.isBusMode;
    }
    get isQueueMode() {
        return !this.store.isBusMode;
    }
    on(topic, callback) {
        return addSubscription({ store: this.store, topicName: topic, callback, singleRun: false });
    }
    with() {
        return this;
    }
    once(topic, callback) {
        if (callback) {
            return addSubscription({ store: this.store, topicName: topic, callback, singleRun: true });
        }
        return new Promise((resolve) => {
            addSubscription({
                store: this.store,
                topicName: topic,
                callback: callbackToResolve(resolve),
                singleRun: true,
            });
        });
    }
    off(topic, callback) {
        return removeSubscription({
            store: this.store,
            topicName: topic,
            callback,
        });
    }
    emit(topic, ...data) {
        return publish({ store: this.store, topicName: topic, data });
    }
    emitRetain(topic, ...data) {
        return publish({ store: this.store, topicName: topic, data, retain: true });
    }
    onModuleLoaded(moduleId, dependencyIds, callback) {
        const register = (params, cb) => {
            const listener = this.moduleEvents.addModuleLoadListener(params, cb);
            this.moduleEvents.emitModuleLoadedListener(listener);
            return listener;
        };
        const params = { moduleId, dependencyIds };
        if (callback) {
            return addModuleSubscription({ callback, params, register });
        }
        return new Promise((resolve) => {
            addModuleSubscription({ callback: resolve, params, register });
        });
    }
    emitModuleLoaded(moduleId) {
        return publish({
            store: this.store,
            topicName: moduleEventName("loaded"),
            data: [{ moduleId }],
        });
    }
    emitModuleInitialized(moduleId) {
        return publish({
            store: this.store,
            topicName: moduleEventName("initialized"),
            data: [{ moduleId }],
        });
    }
    onModuleInitialized(moduleId, dependencyIds, callback) {
        const register = (params, cb) => {
            const listener = this.moduleEvents.addModuleInitializedListener(params, cb);
            this.moduleEvents.emitModuleInitializedListener(listener);
            return listener;
        };
        const params = { moduleId, dependencyIds };
        if (callback) {
            return addModuleSubscription({ callback, params, register });
        }
        return new Promise((resolve) => {
            addModuleSubscription({ callback: resolve, params, register });
        });
    }
}

export { QBusImpl as Q, addModuleSubscription as a, addSubscription as b, publish as p, removeSubscription as r };
/*                                 */
